<template>
  <div class="p-grid">
    <div class="p-col-12 p-pt-1 p-pb-1">

       <div v-if="$route.meta.historyback" class="p-grid p-ai-center p-pt-1 vertical-container">
          <div class="p-col-fixed" style="width:55px;">
              <a @click="$functions.historyBack()" style="cursor: pointer">
                <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
              </a>
          </div>
          <div class="p-col">
              <h3>{{appliance?.name ?? $functions.fixModelName(appliance.modelNumber)}} - {{$t('energy.title')}}</h3>
          </div>
      </div>
      <h2 v-else><a href="#/energy">{{$t('energy.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{appliance?.name ?? $functions.fixModelName(appliance.modelNumber)}}</h2>

      <div class="irinox-form energy">
        <div class="p-d-flex p-jc-between p-ai-center">
          <div class="p-d-flex">
            <h4 class="p-text-bold">{{ $t('energy.total_consumption') }}</h4>
          </div>
          <div class="p-d-flex">
            <div class="p-formgroup-inline p-ai-center">
              <div class="p-field">
                <Dropdown id="period" v-model="periodSelected" :options="periods" optionLabel="name" optionValue="code"
                  :placeholder="$t('filter.period')" />
              </div>
            </div>
          </div>

        </div>

        

        <div class="p-grid p-jc-center">
          <div class="p-col" >
            <div class="p-d-flex p-jc-center">
              <div class="p-formgroup-inline p-ai-center p-jc-center" style="gap: 10px; width: 100%;">
                <EnergyCard 
                  :title="$t('energy.details.working_hours')"
                  :value="appliance.workingHours!= null ? $n(appliance.workingHours, appliance.workingHours<100 ? 'money' : 'integer') : null" 
                  :unit="'h'" 
                  icon="assets/irinox/icons/energy_working_time.svg"
                  mode="small"
                />
                <!-- <EnergyCard 
                  :title="$t('energy.details.cycle_counter')"
                  :tooltip="$t('energy.details.cycle_counter_tooltip')"
                  :value="appliance.cycleCounter!= null ? $n(appliance.cycleCounter, 'integer') : null" 
                  :unit="''" 
                  icon="assets/irinox/icons/energy_cycle_counter.svg"
                  mode="small"
                /> -->
                <EnergyCard 
                  :title="$t('energy.details.estimated_consumption')"
                  :tooltip="$t('energy.details.estimated_consumption_tooltip')"
                  :value="appliance.estimatedConsumption!=null ? $n(appliance.estimatedConsumption, appliance.estimatedConsumption<100 ? 'power' : 'integer') : null" 
                  :unit="'kWh'" 
                  icon="assets/irinox/icons/energy_consumption.svg"
                  mode="small"
                />
                <EnergyCard 
                  :title="$t('energy.details.estimated_expense')"
                  :tooltip="$t('energy.details.estimated_expense_tooltip')"
                  :value="appliance.estimatedExpense!=null ? formatCurrency(appliance.estimatedExpense, appliance.currency) : null" 
                  :unit="$functions.currencies()[appliance.currency]" 
                  icon="assets/irinox/icons/energy_costs.svg"
                  mode="small"
                />
                <EnergyCard 
                  :title="$t('energy.details.estimated_co2')"
                  :tooltip="$t('energy.details.estimated_co2_tooltip')"
                  :value="appliance.estimatedCO2!=null ? $n($functions.weight(appliance.estimatedCO2, isMetric), appliance.estimatedCO2<100 ? 'co2' : 'integer') : null" 
                  :unit="isMetric?'Kg':'lb'" 
                  icon="assets/irinox/icons/energy_green_small.png"
                  mode="small"
                />
              </div>
            </div>
            <div class="p-d-flex p-jc-between p-ai-center p-mt-4">
              <div class="p-field">
                <SelectButton v-model="energyUnit" :options="energyUnitOptions" />
              </div>
              <!-- <EnergyOverview 
                :title="$t('energy.estimated_co2')"
                :value="appliance.estimatedCO2!=null ? $n(appliance.estimatedCO2, 'integer') : null" 
                :unit="'Kg CO2'" 
                icon="assets/irinox/icons/energy_green.png"
              /> -->
            </div>  
            <div>
              <EnergyChart
              :serialNumber="serialNumber" 
              :energyUnit="energyUnit" 
              :period="periodSelected" />
            </div>
          </div>
          <div class="p-col-fixed" style="width: 550px;">
            <h2 style="margin-bottom: 0;">{{$functions.fixModelName(appliance.gamma + ' ' + appliance.modelNumber)}}</h2>
            <!-- <h4 style="margin-top: .5rem;">{{$t('energy.details.live_consumption')}} {{appliance.name}}</h4> -->
            <h4 style="margin-top: .5rem;">{{appliance.serialNumber}}</h4>
            <div class="p-grid">
              <div class="p-col-fixed" style="width: 220px;">
                <img :src="$images.image(appliance.gamma + ' ' + appliance.modelNumber, appliance.accessory, true)"  style="max-width: 240px; max-height: 330px;" :alt="appliance.modelNumber"/>
              </div>
              <div class="p-col">
                <div class="p-d-flex p-flex-column p-mt-4" style="gap: 10px;">
                  <EnergyCard 
                    :title="$t('energy.details.live_consumption')"
                    :value="instantPower!=null ? $n(instantPower, 'power') : null" 
                    :unit="'kW'" 
                    icon="assets/irinox/icons/energy_consumption.svg"
                  />
                  <EnergyCard v-if="role==='USER'"
                    :title="$t('energy.details.unit_cost')"
                    :value="appliance.unitCost ? formatCurrency(appliance.unitCost, appliance.currency) : null" 
                    :unit="appliance.currency? $functions.currencies()[appliance.currency]+'/kWh' : ''"
                    :ctaIcon="`assets/irinox/icons/energy_edit.svg`" 
                    @click:cta="openUnitCostDialog"
                  />
                  <EnergyCard v-else
                    :title="$t('energy.details.unit_cost')"
                    :value="appliance.unitCost ? formatCurrency(appliance.unitCost, appliance.currency) : null" 
                    :unit="appliance.currency? $functions.currencies()[appliance.currency]+'/kWh' : ''"
                  />
                </div>
              </div>

            </div>
          </div>

        </div>


        <h4 class="p-text-bold p-mb-1">{{ $t('energy.details.total_consumption_per_cycle') }}</h4>
        <div>{{ $t('energy.data_period') }} {{ $d($moment().subtract(periodSelected, 'days').toDate(), 'shortNumeric') }} - {{ $d(new Date(), 'shortNumeric') }}</div>

        <DataTable v-if="appliance.gamma==='MF Next' || appliance.gamma==='EF Next'" :value="appliance.cycles" stripedRows 
            responsiveLayout="stack" 
            breakpoint="960px" 
            :autoLayout="true" sortField="startTimestamp" :sortOrder="-1" class="p-mt-3 energy-table">

            <Column field="name" :header="$t('energy.details.col_cycle_name')" sortable ></Column>

            <Column field="startTimestamp" :header="$t('energy.details.col_date')" sortable >
              <template #body="slotProps">
                {{ $d( $functions.utcDate(slotProps.data.startTimestamp,1) , is24hour ? 'cycle' : 'cycle12' ) }}
              </template>
            </Column>

            <Column field="function" :header="$t('energy.details.col_function')" sortable >
              <template #body="slotProps">
                <span v-if="appliance.gamma==='MF Next'">{{$t('mf.functions.'+slotProps.data.function)}}</span>
                <span v-if="appliance.gamma==='EF Next'">{{$t('ef.functions.'+slotProps.data.function)}}</span>
              </template>
            </Column>

            <!-- <Column field="type" :header="$t('energy.details.col_type')" sortable >
              <template #body="slotProps">
                <img v-if="slotProps.data.type===0 || slotProps.data.type===1" :src="'assets/irinox/cycles/mf_type_'+slotProps.data.type+'.svg'" width="55" :alt="$t('library.filter_type_ph')"/>
              </template>
            </Column> -->

            <Column field="estimatedConsumption" :header="$t('energy.details.col_estimated_consumption')" sortable>
              <template #body="slotProps">
                {{ slotProps.data.estimatedConsumption!=null ? $n(slotProps.data.estimatedConsumption,'power') : '-'}} kWh
              </template>
            </Column>

            <Column field="estimatedExpense" :header="$t('energy.details.col_estimated_expense')" sortable>
              <template #body="slotProps">
                {{ slotProps.data.estimatedExpense!=null ? formatCurrency(slotProps.data.estimatedExpense,appliance.currency, true) : '-'}}
              </template>
            </Column>
            
            <Column ></Column>

          </DataTable>
        <DataTable v-else-if="appliance.gamma==='CP' || appliance.gamma==='CK'" :value="appliance.cycles" stripedRows 
            responsiveLayout="stack" 
            breakpoint="960px" 
            :autoLayout="true" sortField="startTimestamp" :sortOrder="-1" class="p-mt-3 energy-table">

            <Column field="startTimestamp" :header="$t('energy.details.col_date')" sortable >
              <template #body="slotProps">
                {{ $d( $functions.utcDate(slotProps.data.startTimestamp,1) , is24hour ? 'cycle' : 'cycle12' ) }}
              </template>
            </Column>

            <Column field="estimatedConsumption" :header="$t('energy.details.col_estimated_consumption')" sortable>
              <template #body="slotProps">
                {{ slotProps.data.estimatedConsumption!=null ? $n(slotProps.data.estimatedConsumption,'power') : '-'}} kWh
              </template>
            </Column>

            <Column field="estimatedExpense" :header="$t('energy.details.col_estimated_expense')" sortable>
              <template #body="slotProps">
                {{ slotProps.data.estimatedExpense!=null ? formatCurrency(slotProps.data.estimatedExpense,appliance.currency, true) : '-'}}
              </template>
            </Column>
            
            <Column ></Column>

          </DataTable>






      </div>
    </div>
  </div>
  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('energy.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  <EnergyEditUnitCost :visible="dialog.editUnitCost" :serialNumber="serialNumber"
    @update:visible="dialog.editUnitCost = $event" :unitCost="appliance.unitCost" @update:unitCost="reloadAppliance()" :currency="appliance.currency"/>

</template>

<script>
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ApplianceService from '../../service/ApplianceService';
import EnergyService from '../../service/EnergyService';
import EnergyCard from './EnergyCard.vue';
// import EnergyOverview from './EnergyOverview.vue';
import { mapGetters } from 'vuex';
import EnergyEditUnitCost from './EnergyEditUnitCost.vue';
import EnergyChart from './EnergyChart.vue';

export default {
  components: {
    IrinoxDialogDark,
    EnergyCard,
    // EnergyOverview,
    EnergyEditUnitCost,
    EnergyChart,
  },
  data() {
    return {
      serialNumber: this.$route.params.serialNumber,
      msConverter: 1000, // Set it to 1000 if API response is in seconds or to 1 if milliseconds
      periods: [{
        code: 7,
        name: this.$t('filter.period_last_w')
      }, {
        code: 30,
        name: this.$t('filter.period_last_1m')
      }, {
        code: 60,
        name: this.$t('filter.period_last_2m')
      }, {
        code: 90,
        name: this.$t('filter.period_last_3m')
      }],
      periodSelected: 7,
      energyUnit: 'kWh',
      energyUnitOptions: ['kWh'],
      appliance: {},
      instantPower: null,
      instantPowerInterval: null,
      dialog: {
        error: false,
        editUnitCost: false,
      }
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      is24hour: 'userdata/is24hour',
      role: 'userdata/role',
      isMetric: 'userdata/isCelsius',
    }),
  },
  watch: {
    'periodSelected': 'reloadAppliance'
  },
  created() {
    this.applianceService = new ApplianceService();
    this.energyService = new EnergyService();
  },
  mounted() {
    this.reloadAppliance();
    this.instantPowerInterval = setInterval(() => {
      console.log("interval")
      if (
        this.appliance.online &&
        (this.appliance.type === 'CONSERVATORE' ||
          (this.appliance.type === 'ABBATTITORE' && (this.appliance.gamma === 'MF Next' || this.appliance.gamma === 'EF Next')))
      ) {
          this.getInstantPower();
      }
    }, 20000);
  },
  beforeUnmount() {
    if (this.instantPowerInterval) {
      console.log("clear interval")
      clearInterval(this.instantPowerInterval);
    }
  },
  methods: {
    formatCurrency(value, currency, showUnit = false) {
      if(value == null) return '-';
      let fmt = this.$n(value, value<100 ? 'money' : 'integer', this.$functions.currencyOpt(currency));
      if(showUnit) {
        fmt +=  ' ' + this.$functions.currencies()[currency];
      }
      return fmt;
    },
    reloadAppliance() {
      let startTimestamp = this.$moment().subtract(this.periodSelected, 'days').startOf('day').unix() * this.msConverter;
      this.applianceService.getApplianceEnergyDetail(this.personaltoken, this.serialNumber, startTimestamp)
        .then((data) => {
          if (data.code == "200") {
            this.appliance = data.body;
            this.energyUnit = 'kWh';
            this.energyUnitOptions = ['kWh', this.appliance.currency];
            if (
              this.appliance.online &&
              (this.appliance.type === 'CONSERVATORE' ||
                (this.appliance.type === 'ABBATTITORE' && (this.appliance.gamma === 'MF Next' || this.appliance.gamma === 'EF Next')))
            ) {
                this.getInstantPower();
            }
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    openUnitCostDialog() {
      this.dialog.editUnitCost = true;
    },
    getInstantPower() {
      this.energyService.getInstantPower(this.personaltoken, this.serialNumber)
        .then((data) => {
          // console.log("ENERGY " + data);
          if(data.code == "200") {
            this.instantPower = data.body;
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.instantPower = null;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.instantPower = null;
        });
    }
  },
}
</script>

<style scoped>
</style>